import { Layouts } from '../../../controls/layouts';
import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LinkComponent } from 'src/app/controls/components/basic/link/link.component';
import { CreatedEntity, ItemStatus } from 'src/app/partnerportal/models/partner-onboarding';
import { SectionBoxComponent } from '../../onboarding-setup/partner-onboarding-transport/components/section-box/section-box.component';

@Component({
  selector: 'app-partner-onboarding-information-group',
  standalone: true,
  imports: [FormsModule, LinkComponent, Layouts, SectionBoxComponent],
  templateUrl: './partner-onboarding-information-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './partner-onboarding-information-group.component.scss'
})
export class PartnerOnboardingInformationGroupComponent {
  public title = input<string>('');
  public supportsAcceptance = input<boolean>(true);
  public supportsRemove = input<boolean>(true);
  public createdEntities = input<CreatedEntity[]>([]);
  public mainItemStatus = input.required<ItemStatus>();
  public acceptClicked = output<void>();
  public removeClicked = output<void>();
  public reopenClicked = output<void>();
  public entityClicked = output<number>();


  statusText = computed(() => {
      const status = this.mainItemStatus();
      if (status?.toLowerCase() === 'accepted') {
          return 'Accepted';
      } else if (status?.toLowerCase() === 'awaitingacceptance') {
          return 'Awaiting acceptance';
      } else if (status?.toLowerCase() === 'open') {
          return 'Open for partner input';
      }
      return status;
  });

  statusClass = computed(() => {
      const status = this.mainItemStatus();
      if (status?.toLowerCase() === 'accepted') {
          return 'accepted-text';
      } else if (status?.toLowerCase() === 'awaitingacceptance') {
          return 'awaiting-text';
      } else if (status?.toLowerCase() === 'open') {
          return 'open-text';
      }
      return '';
  });

  showAccept = computed(() => { 
    const status = this.mainItemStatus()?.toLowerCase();
    return this.supportsAcceptance() && (status === 'open' || status === 'awaitingacceptance');
  });

  showReopen = computed(() => { 
    const status = this.mainItemStatus()?.toLowerCase();
    return this.supportsAcceptance() && (status === 'accepted' || status === 'awaitingacceptance');
  });

  reopen() {
    this.reopenClicked.emit();
  }

  accept() {
    this.acceptClicked.emit();
  }

  remove() {
    this.removeClicked.emit();
  }

  entityClick(entityId: number): void {
    this.entityClicked.emit(entityId);
  }
}
